export enum AttributeValueType {
  FREE = 'FREE',
  ADD_PRICE = 'ADD_PRICE',
}
